import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=08547fce&scoped=true&lang=pug"
import script from "./Blog.vue?vue&type=script&lang=ts"
export * from "./Blog.vue?vue&type=script&lang=ts"
import style0 from "./Blog.vue?vue&type=style&index=0&id=08547fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08547fce",
  null
  
)

export default component.exports